import workWechat from './workWechat'
import { Notify } from 'vant'

export const wxAuth = () => {
  console.log('加载上微信的jssdk了')
  if (window.wx) { // 加载上微信的jssdk了
    return workWechat.auth.auth()
  } else {
    // Notify({ type: 'danger', message: '请在应用内访问本页面' })
  }
}

export const workWechatJsApi = window.wx
